import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home.vue'

import PerformanceReport
from '@/views/reports/PerformanceReport.vue'

import CustomerPerformanceReport
from '@/views/reports/CustomerPerformanceReport.vue'
Vue.use(Router)

export default new Router({

    routes:[

        {
            path:'/',
            component:Home
        },

        {
            path:'/report/performance',
            component:PerformanceReport
        },
		{
			path:'/report/customer-performance',

			name:'customerPerformance',

			component:
				CustomerPerformanceReport
		}
    ]

})